import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser, useClerk } from '@clerk/clerk-react';
import { Menu, X, LogOut } from 'lucide-react';

const Navigation = () => {
  const { isSignedIn, user } = useUser();
  const clerk = useClerk();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await clerk.signOut();
    navigate('/');
    setMobileMenuOpen(false);
  };

  const isAdmin = user?.publicMetadata?.role === 'admin' || user?.publicMetadata?.role === 'super_admin';

  return (
    <nav className="bg-gradient-to-r from-secondary to-secondary/90 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
           {/* Logo + Brand Name */}
<Link to="/" className="flex items-center gap-3 group">
  <img 
    src="/logo.png" 
    alt="Uni9ja Hub" 
    className="h-12 w-auto object-contain shadow-sm hover:shadow-md transition-shadow duration-300" 
  />
  <span className="text-white font-bold text-lg sm:text-xl tracking-wide whitespace-nowrap">
    UNI9JA MEDIA HUB
  </span>
</Link>

  {/* Rest of your navbar items (e.g., Feed, Contests, Profile, Logout) go here */}


          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {isSignedIn ? (
              <>
                <Link to="/feed" className="text-white/80 hover:text-primary transition font-medium">Feed</Link>
                <Link to="/contests" className="text-white/80 hover:text-primary transition font-medium">Contests</Link>
                <Link to="/quiz" className="text-white/80 hover:text-primary transition font-medium">Quiz</Link>
                {isAdmin && (
                  <Link to="/admin" className="text-white/80 hover:text-primary transition font-medium">⚙️ Admin</Link>
                )}
                <div className="flex items-center gap-4">
                  <span className="text-white text-sm">{user?.firstName}</span>
                  <button onClick={handleLogout} className="bg-primary hover:bg-primary/90 text-secondary px-4 py-2 rounded-lg font-semibold flex items-center gap-2 transition">
                    <LogOut size={16} /> Logout
                  </button>
                </div>
              </>
            ) : (
              <>
                <Link to="/login" className="text-white/80 hover:text-primary transition font-medium">Login</Link>
                <Link to="/signup" className="bg-primary hover:bg-primary/90 text-secondary px-6 py-2 rounded-lg font-semibold transition">Get Started</Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white hover:text-primary transition">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-white/10">
            {isSignedIn ? (
              <>
                <Link to="/feed" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">Feed</Link>
                <Link to="/contests" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">Contests</Link>
                <Link to="/quiz" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">Quiz</Link>
                {isAdmin && (
                  <Link to="/admin" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">⚙️ Admin</Link>
                )}
                <button onClick={handleLogout} className="w-full mt-4 bg-primary hover:bg-primary/90 text-secondary px-4 py-2 rounded-lg font-semibold transition">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">Login</Link>
                <Link to="/signup" onClick={() => setMobileMenuOpen(false)} className="block py-3 text-white/80 hover:text-primary font-medium">Get Started</Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;